import React, { createContext, useCallback, useContext, useState } from 'react';

interface LcaImportContextValue {
  importVersion: number;
  notifyImported: () => void;
}

const LcaImportContext = createContext<LcaImportContextValue | null>(null);

export const LcaImportContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [importVersion, setImportVersion] = useState(0);
  const notifyImported = useCallback(() => setImportVersion((v) => v + 1), []);
  return <LcaImportContext.Provider value={{ importVersion, notifyImported }}>{children}</LcaImportContext.Provider>;
};

const useLcaImportContext = (): LcaImportContextValue => {
  const ctx = useContext(LcaImportContext);
  if (ctx === null) {
    throw new Error('useLcaImportContext must be used within a LcaImportContextProvider');
  }
  return ctx;
};

export const useLcaImportVersion = () => useLcaImportContext().importVersion;
export const useNotifyLcaImported = () => useLcaImportContext().notifyImported;
